// Controlled vocabularies for the Prospect Database — deterministic, NO AI.
export const DISTRESS_TYPES = ["Pre-Foreclosure", "Notice of Default", "Notice of Trustee Sale", "Foreclosure",
  "Auction", "Bankruptcy", "Tax Delinquent", "Tax Sale", "Probate", "Vacant", "Absentee Owner",
  "High Equity", "Expired Listing", "Failed Listing", "Code Violation", "Other"];

export const AUCTION_STATUSES = ["Auction Scheduled", "Auction Pending", "Auction Cancelled", "Auction Postponed",
  "Auction Completed", "No Auction Date", "Foreclosure Active", "Foreclosure Completed", "Unknown"];

export const VERIFICATION_STATUSES = [
  ["verified", "Verified"], ["partially_verified", "Partially Verified"], ["unverified", "Unverified"],
  ["stale", "Stale"], ["conflicting", "Conflicting Data"],
];

export const VERIF_LABELS = Object.fromEntries(VERIFICATION_STATUSES);

export const VERIF_BADGE = {
  verified: "bg-emerald-100 text-emerald-800 border-emerald-200",
  partially_verified: "bg-sky-100 text-sky-800 border-sky-200",
  unverified: "bg-zinc-100 text-zinc-700 border-zinc-200",
  stale: "bg-amber-100 text-amber-800 border-amber-200",
  conflicting: "bg-red-100 text-red-800 border-red-200",
};

export const DATE_OPS = [
  ["next7", "Next 7 days"], ["next30", "Next 30 days"], ["next60", "Next 60 days"], ["next90", "Next 90 days"],
  ["past_due", "Past due"], ["exact", "Exact date"], ["before", "Before"], ["after", "After"], ["between", "Between"],
];

export const PROSPECT_LEAD_STATUSES = ["Prospect", "Researching", "Contacted", "Lead Created", "Dead"];
